import React, { Component } from "react";
import { loading } from "../components/CustomComponent.js";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import { PageHero, SectionHead, FeatureCard, CtaBand, Reveal } from "../components/ui.js";

/* ============================================================
   LEVELUP ONE — Career
   ============================================================ */

export default class Career extends Component {
  componentDidMount() {
    loading(false);
    window.scrollTo(0, 0);
  }

  render() {
    const perks = [
      { icon: "🏖️", title: "ทำงานยืดหยุ่น", desc: "Hybrid และเวลายืดหยุ่น โฟกัสที่ผลงาน" },
      { icon: "📈", title: "เติบโตเร็ว", desc: "ได้ลงมือกับโปรเจกต์จริงและเทคโนโลยีใหม่" },
      { icon: "🎓", title: "งบเรียนรู้", desc: "สนับสนุนคอร์สและงานสัมมนาทุกปี" },
      { icon: "🩺", title: "สวัสดิการครบ", desc: "ประกันสุขภาพและโบนัสตามผลงาน" },
    ];

    const jobs = [
      { title: "Frontend Developer (React)", type: "Full-time", loc: "ระยอง / Remote", level: "Mid–Senior" },
      { title: "Backend Developer (Node.js)", type: "Full-time", loc: "ระยอง / Remote", level: "Mid–Senior" },
      { title: "AI/ML Engineer", type: "Full-time", loc: "Remote", level: "Senior" },
      { title: "Product Designer (UX/UI)", type: "Full-time", loc: "ระยอง / Remote", level: "Mid" },
      { title: "Customer Success", type: "Full-time", loc: "ระยอง", level: "Junior–Mid" },
    ];

    return (
      <div className="nx">
        <Navbar />
        <PageHero
          crumb="ร่วมงานกับเรา"
          eyebrow="ร่วมงานกับเรา"
          title="มาสร้างพนักงาน AI ไปด้วยกัน"
          subtitle="เรากำลังมองหาเพื่อนร่วมทีมที่อยากสร้างผลกระทบจริงให้ธุรกิจไทย"
        />

        <section className="nx-section">
          <div className="container">
            <Reveal><SectionHead center eyebrow="ทำไมต้องร่วมงานกับเรา" title="วัฒนธรรมที่ให้คุณเติบโต" /></Reveal>
            <div className="row g-4 mt-2">
              {perks.map((p, i) => (
                <div className="col-12 col-sm-6 col-lg-3" key={p.title}>
                  <Reveal delay={i * 60}><FeatureCard {...p} /></Reveal>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="nx-section nx-bg-surface">
          <div className="container">
            <Reveal><SectionHead eyebrow="ตำแหน่งที่เปิดรับ" title="ร่วมทีมกับเรา" subtitle="ไม่เจอตำแหน่งที่ใช่? ส่งโปรไฟล์มาได้เลย เรายินดีพูดคุย" /></Reveal>
            <div className="d-flex flex-column gap-3 mt-4">
              {jobs.map((j, i) => (
                <Reveal key={j.title} delay={i * 50}>
                  <div className="nx-job">
                    <div>
                      <div className="nx-job__title">{j.title}</div>
                      <div className="nx-job__meta">
                        <span>💼 {j.type}</span>
                        <span>📍 {j.loc}</span>
                        <span className="nx-badge">{j.level}</span>
                      </div>
                    </div>
                    <a href="mailto:jobs@levelupone.ai?subject=สมัครงาน" className="nx-btn nx-btn--ghost">สมัครงาน</a>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </section>

        <CtaBand
          title="ไม่เจอตำแหน่งที่ใช่?"
          text="ส่งเรซูเม่ของคุณมาที่ jobs@levelupone.ai เราเก็บไว้พิจารณาเสมอ"
        />
        <Footer />
      </div>
    );
  }
}
